import './moreProjects.scss';
import { Link } from '@reach/router';
import * as React from 'react';
import { RoutePaths } from '../../routes';
import { RMButton } from '../layout/rmButton';
export const MoreProjects = () => (<div className="more-projects">
    <Link to={RoutePaths.projects.projectsBrowse()}>
      <RMButton variant="brand-secondary">More Projects</RMButton>
    </Link>
  </div>);
